import React from "react";
import { useLocation } from "react-router";

import styles from "./RouteTransition.module.css";

interface RouteTransitionProps {
  children: React.ReactNode;
}

export const RouteTransition: React.FC<RouteTransitionProps> = ({
  children,
}) => {
  const location = useLocation();

  return (
    <div key={location.pathname} className={styles.page}>
      {children}
    </div>
  );
};
